// extracted by mini-css-extract-plugin
export default {"line":"PanelSeparator-module--line--dceb1","triangle":"PanelSeparator-module--triangle--a2355"};